const Musee = () => {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.75 20H31.25C31.9375 20 32.5 19.4375 32.5 18.75V3.75C32.5 3.0625 31.9375 2.5 31.25 2.5H8.75C8.0625 2.5 7.5 3.0625 7.5 3.75V18.75C7.5 19.4375 8.0625 20 8.75 20ZM10 5H30V17.5H25.625L16.875 10L10 15V5Z"
        fill="currentColor"
      />
      <path
        d="M36.875 25.625C36.875 24.5875 36.0375 23.75 35 23.75C33.9625 23.75 33.125 24.5875 33.125 25.625C33.125 25.7188 33.1376 25.8063 33.15 25.8938C29.55 27.5312 25.4501 27.5312 21.8438 25.8938C21.8563 25.8063 21.8688 25.7188 21.8688 25.625C21.8688 24.5875 21.0313 23.75 19.9938 23.75C18.9563 23.75 18.1188 24.5875 18.1188 25.625C18.1188 25.7188 18.1313 25.8063 18.1438 25.8938C14.5438 27.5312 10.4438 27.5312 6.83755 25.8938C6.85005 25.8063 6.86255 25.7188 6.86255 25.625C6.86255 24.5875 6.02505 23.75 4.98755 23.75C3.95005 23.75 3.11255 24.5875 3.11255 25.625C3.11255 26.1813 3.3563 26.6688 3.73755 27.0125V37.5H6.23755V27.0125C6.23755 27.0125 6.25005 27.0063 6.2563 27C10.225 28.825 14.7563 28.825 18.725 27C18.725 27 18.7375 27.0063 18.7438 27.0125V37.5H21.2438V27.0125C21.2438 27.0125 21.2563 27.0063 21.2626 27C23.2438 27.9125 25.3688 28.375 27.4938 28.375C29.6188 28.375 31.7438 27.9125 33.725 27C33.725 27 33.7376 27.0063 33.7438 27.0125V37.5H36.2438V27.0125C36.625 26.6688 36.8688 26.175 36.8688 25.625H36.875Z"
        fill="currentColor"
      />
      <path
        d="M25.625 11.25C26.6605 11.25 27.5 10.4105 27.5 9.375C27.5 8.33947 26.6605 7.5 25.625 7.5C24.5895 7.5 23.75 8.33947 23.75 9.375C23.75 10.4105 24.5895 11.25 25.625 11.25Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default Musee;
